import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { useReveal } from "../lib/motion";

const steps = [
    { n: "01", title: "Download & onboard",
      text: "Tell us about your cycle history, goals (tracking, trying-to-conceive, pregnancy, peri-menopause), and any conditions. Takes 3 minutes." },
    { n: "02", title: "Log your first cycle",
      text: "Mark your period start. Add symptoms, mood, and sleep as you go. The more you log, the smarter Femcare gets." },
    { n: "03", title: "Receive personalized predictions",
      text: "After a few cycles, FemCare's algorithm predicts your next period, fertile window, and ovulation — and keeps refining as it learns your rhythm." },
    { n: "04", title: "Unlock AI insights (Premium)",
      text: "Hormonal Wellness Reports, symptom clusters, and 24/7 AI Care Assistant — in English & Hindi." },
    { n: "05", title: "Export & share your journey",
      text: "Download beautiful PDF wellness reports summarising your cycles, symptoms and insights — private, offline, and yours." },
];

export default function Services() {
    useReveal();
    return (
        <div data-testid="services-page">
            <PageHero
                testId="services-hero"
                overline="How it works"
                title={
                    <>
                        Five steps to<br />
                        <span className="italic font-light">knowing your body</span> deeply.
                    </>
                }
                size="lg"
            />

            <section className="max-w-5xl mx-auto px-6 lg:px-12 pb-24 relative">
                {/* vertical timeline line */}
                <div className="hidden md:block absolute left-[calc(50%-0.5px)] top-0 bottom-24 w-px bg-gradient-to-b from-femcare-pink/40 via-femcare-accent/30 to-transparent" />

                <div className="space-y-6">
                    {steps.map((s, i) => (
                        <div
                            key={s.n}
                            className={`card-editorial p-8 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-start reveal reveal-delay-${(i % 4) + 1}`}
                            data-testid={`step-${s.n}`}
                        >
                            <div className="md:col-span-2 flex md:justify-center">
                                <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-femcare-pink/10 border border-femcare-pink/20">
                                    <span className="font-serif text-3xl text-femcare-pink leading-none">{s.n}</span>
                                </div>
                            </div>
                            <div className="md:col-span-10">
                                <h3 className="font-serif text-2xl md:text-3xl text-femcare-purple mb-3">{s.title}</h3>
                                <p className="text-femcare-purple/70 leading-relaxed text-lg">{s.text}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center reveal">
                    <Link to="/pricing" className="btn-primary magnet" data-testid="services-cta">
                        Start your journey
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </section>
        </div>
    );
}
